

































import { proxyModel } from "@/common/utils/proxyModel";
import { ErrorTrackingFilterForm } from "../forms/ErrorTrackingFilterForm";
import Vue from "vue";
export default Vue.extend({
  props: {
    value: {
      type: Object as () => ErrorTrackingFilterForm
    },
    useSearch: {
      type: Boolean
    }
  },
  computed: {
    ...proxyModel("search", "status")
  },
  methods: {
    async changeStatusOption() {
      this.$emit("changeStatusOption");
    }
  }
});
